import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin, CalendarDays, Users, Layers } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const DESTINATIONS = ["all", "Monaco", "Cannes", "Nice", "Saint-Tropez", "Antibes", "Saint-Jean-Cap-Ferrat"];

export const SearchBar = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [category, setCategory] = useState("all");
  const [destination, setDestination] = useState("all");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [guests, setGuests] = useState(1);

  const CATEGORIES = [
    { value: "all", label: t("search.allCategories") },
    { value: "cars", label: t("nav.cars") },
    { value: "yachts", label: t("nav.yachts") },
    { value: "properties", label: t("nav.villas") },
  ];

  const submit = () => {
    const params = new URLSearchParams();
    if (category !== "all") params.set("category", category);
    if (destination !== "all") params.set("destination", destination);
    if (start) params.set("start", start);
    if (end) params.set("end", end);
    if (guests > 1) params.set("guests", guests);
    const catPath = category === "cars" ? "/voitures" : category === "yachts" ? "/yachts" : category === "properties" ? "/villas" : "/recherche";
    navigate(`${catPath}?${params.toString()}`);
  };

  const fieldClass =
    "w-full bg-transparent text-[#F5F7F5] text-sm outline-none placeholder:text-[#7E8C84] [color-scheme:dark]";
  const wrapClass =
    "flex flex-col gap-1.5 px-4 py-3 border-b md:border-b-0 md:border-r border-white/10 last:border-none";
  const labelClass =
    "flex items-center gap-1.5 text-[10px] tracking-widest uppercase text-[#D4AF37]/80";

  return (
    <div
      data-testid="global-search-bar"
      className="gz-glass rounded-3xl shadow-2xl p-2 md:p-2.5"
    >
      <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1.2fr_1fr_1fr_0.8fr_auto] items-stretch">
        <div className={wrapClass}>
          <span className={labelClass}><Layers className="w-3 h-3" /> {t("search.category")}</span>
          <select data-testid="search-category" value={category} onChange={(e) => setCategory(e.target.value)} className={fieldClass}>
            {CATEGORIES.map((c) => (
              <option key={c.value} value={c.value} className="bg-[#0E0D0A]">{c.label}</option>
            ))}
          </select>
        </div>
        <div className={wrapClass}>
          <span className={labelClass}><MapPin className="w-3 h-3" /> {t("search.destination")}</span>
          <select data-testid="search-destination" value={destination} onChange={(e) => setDestination(e.target.value)} className={fieldClass}>
            {DESTINATIONS.map((d) => (
              <option key={d} value={d} className="bg-[#0E0D0A]">{d === "all" ? t("search.allDestinations") : d}</option>
            ))}
          </select>
        </div>
        <div className={wrapClass}>
          <span className={labelClass}><CalendarDays className="w-3 h-3" /> {t("search.arrival")}</span>
          <input data-testid="search-start-date" type="date" value={start} onChange={(e) => setStart(e.target.value)} className={fieldClass} />
        </div>
        <div className={wrapClass}>
          <span className={labelClass}><CalendarDays className="w-3 h-3" /> {t("search.departure")}</span>
          <input data-testid="search-end-date" type="date" value={end} onChange={(e) => setEnd(e.target.value)} className={fieldClass} />
        </div>
        <div className={wrapClass}>
          <span className={labelClass}><Users className="w-3 h-3" /> {t("search.guests")}</span>
          <input data-testid="search-guests" type="number" min="1" value={guests} onChange={(e) => setGuests(Number(e.target.value))} className={fieldClass} />
        </div>
        <div className="p-2 flex items-stretch">
          <button
            onClick={submit}
            data-testid="global-search-submit"
            className="w-full md:w-auto h-full flex items-center justify-center gap-2 rounded-2xl bg-[#D4AF37] hover:bg-[#B8912A] text-white font-semibold px-6 py-3 transition-colors duration-300"
          >
            <Search className="w-4 h-4" />
            <span className="text-sm">{t("search.search")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
